module.exports = __webpack_public_path__ + "static/media/samsung-aife-2020-battery-poster.f33f1fc3.jpg";